import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { bindEnterpriseWechat } from '@/api/user';

// 企业微信自建应用（水滴）：正式与测试的 agentid 不同
var WECOM_CORP_ID = 'wwe3ff1f82b1a8f236';
var WECOM_AGENT_ID = process.env.VUE_APP_NAME === 'production' ? '1000067' : '1000046';

// 官方 CDN 的登录组件，按需加载，不额外增加依赖
var WECOM_SDK_URL = 'https://wwcdn.weixin.qq.com/node/wework/wwopen/js/wecom-jssdk-2.4.0.js';
var sdkPromise = null;

// 加载企业微信 JS-SDK，加载完成后全局挂载 window.ww
function loadWecomSdk() {
  if (window.ww) return Promise.resolve(window.ww);
  if (!sdkPromise) {
    sdkPromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = WECOM_SDK_URL;
      script.onload = function () {
        return window.ww ? resolve(window.ww) : reject(new Error('ww 未挂载'));
      };
      script.onerror = function () {
        return reject(new Error('企业微信 JS-SDK 加载失败'));
      };
      document.head.appendChild(script);
    }).catch(function (error) {
      // 失败后清掉缓存，下次打开弹窗可以重试
      sdkPromise = null;
      throw error;
    });
  }
  return sdkPromise;
}

// 登录组件错误码说明见企业微信文档 Web登录组件-附录
var LOGIN_FAIL_TIPS = {
  '-31020': 'redirect_uri 与配置的登录授权域名不一致',
  '-31027': 'appid 参数错误',
  '-31028': 'agentid 参数错误',
  '-31033': '校验请求来源错误，请确认当前域名已配置为企业微信可信域名',
  '-31035': 'redirect_uri 不能为空',
  '-31039': 'redirect_uri 与配置的可信域名不一致',
  '-31040': 'login_type 参数错误'
};
export default {
  name: 'BindWecomDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loginPanel: null,
      state: ''
    };
  },
  computed: {
    // 不直接改 prop，关闭动作回传给父组件，避免父组件状态残留导致弹窗反复弹出
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(value) {
        this.$emit('update:visible', value);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroyLoginPanel();
  },
  methods: {
    // localhost 不能作为企微可信域名，本地开发回退到测试域名（同登录页 getFullAddress）
    getRedirectUri: function getRedirectUri() {
      var fullAddress = "".concat(window.location.protocol, "//").concat(window.location.hostname);
      return fullAddress === 'http://localhost' ? 'https://package-adv-webtest.youlianfuwu.com' : fullAddress;
    },
    createLoginPanel: function createLoginPanel() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var ww, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return loadWecomSdk();
            case 1:
              ww = _context.v;
              _this.state = "bind_".concat(Date.now(), "_").concat(Math.random().toString(36).slice(2, 10));
              _this.loginPanel = ww.createWWLoginPanel({
                el: _this.$refs.loginPanel,
                params: {
                  login_type: 'CorpApp',
                  appid: WECOM_CORP_ID,
                  agentid: WECOM_AGENT_ID,
                  redirect_uri: _this.getRedirectUri(),
                  state: _this.state,
                  redirect_type: 'callback'
                },
                onLoginSuccess: _this.handleLoginSuccess,
                onLoginFail: _this.handleLoginFail
              });
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              _this.$message.error('企业微信登录组件加载失败，请刷新后重试');
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }))();
    },
    destroyLoginPanel: function destroyLoginPanel() {
      var panel = this.loginPanel;
      this.loginPanel = null;
      if (!panel) return;
      try {
        panel.unmount();
      } catch (error) {
        // iframe 可能已随弹窗销毁，忽略卸载异常
      }
    },
    handleLoginSuccess: function handleLoginSuccess(_ref) {
      var _this2 = this;
      var code = _ref.code;
      bindEnterpriseWechat({
        code: code,
        source: 'enterpriseWechat'
      }).then(function () {
        _this2.$message.success('绑定成功');
        _this2.dialogVisible = false;
        // 绑定成功后通知父组件隐藏入口
        _this2.$emit('bind-success');
      }).catch(function () {
        // 失败原因由请求拦截器统一提示，关闭弹窗避免停留在已失效的面板上
        _this2.dialogVisible = false;
      });
    },
    handleLoginFail: function handleLoginFail(error) {
      var errCode = String(error && (error.errCode || error.code) || '');
      this.$message.error(LOGIN_FAIL_TIPS[errCode] || error && error.errMsg || '企业微信登录失败，请重试');
      this.dialogVisible = false;
    }
  }
};